
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"62","height":"62","viewBox":"0 0 62 62"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1231 -150)"}},[_c('rect',{attrs:{"width":"54","height":"54","rx":"8","transform":"translate(1231 150)","fill":"#245389","opacity":".1"}}),_c('path',{attrs:{"d":"M1284.379 189.118h-6.438a1.422 1.422 0 01-1.412-1.412v-13.153a5.206 5.206 0 015.2-5.2h.019a8.934 8.934 0 018.881 8.941v4.559a5.913 5.913 0 01-6.25 6.265zm-5.026-2.823h5.026a3.141 3.141 0 003.444-3.442v-4.559a6.106 6.106 0 00-6.08-6.118h-.014a2.366 2.366 0 00-1.675.7 2.334 2.334 0 00-.7 1.675z","fill":"#245389"}}),_c('path',{attrs:{"d":"M1264.941 210.739a3.222 3.222 0 01-2.334-.975l-3.125-3.13a.464.464 0 00-.621-.037l-3.219 2.4a3.29 3.29 0 01-5.271-2.625v-28.119c0-5.657 3.257-8.9 8.941-8.9h22.589a1.419 1.419 0 011.412 1.406 1.419 1.419 0 01-1.412 1.406 2.349 2.349 0 00-2.353 2.343v31.864a3.291 3.291 0 01-5.271 2.624l-3.219-2.4a.459.459 0 00-.6.037l-3.164 3.15a3.357 3.357 0 01-2.353.956zm-5.817-7.048a3.252 3.252 0 012.353.975l3.125 3.13a.5.5 0 00.678 0l3.162-3.149a3.285 3.285 0 014.311-.281l3.2 2.38a.432.432 0 00.489.037.466.466 0 00.264-.412v-31.864a5.127 5.127 0 01.565-2.342h-17.977c-4.179 0-6.123 1.93-6.123 6.088v28.119a.475.475 0 00.264.431.441.441 0 00.489-.056l3.219-2.4a3.334 3.334 0 011.981-.656z","fill":"#245389"}}),_c('path',{attrs:{"d":"M1270.532 185.289h-11.294a1.422 1.422 0 01-1.412-1.412 1.422 1.422 0 011.412-1.412h11.294a1.422 1.422 0 011.412 1.412 1.422 1.422 0 01-1.412 1.412zM1269.118 192.787h-8.471a1.422 1.422 0 01-1.412-1.412 1.422 1.422 0 011.412-1.412h8.471a1.422 1.422 0 011.412 1.412 1.422 1.422 0 01-1.412 1.412z","fill":"#f29030"}})])])
          )
        }
      }
    